import {Component, EffectRef, inject, isDevMode, OnDestroy, signal} from '@angular/core';
import {Store} from '@ngrx/store';
import {
  hideLoadingProcessInfoSseStream,
  removeInfoErrorMessage,
  startProcessInfoSseStream
} from '../../services/process-info.actions';
import {
  selectIsConnected,
  selectLastProcessInfo,
  selectProcessLastErrorMessages,
  selectProcessLastInfo,
  selectShowMessage,
} from '../../services/process-info.selectors';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatBadgeModule} from '@angular/material/badge';
import {ProcessInfoWindowComponent} from '../process-info-window/process-info-window.component';
import {selectPapers} from '../../../research/services/research-paper/research-paper.selectors';
import {
  ResearchPaperCardComponent
} from '../../../research/components/research-paper-card/research-paper-card.component';
import {ResearchPaperDTO} from '../../../research/dto/research-paper';

@Component({
  selector: 'app-show-message',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatBadgeModule,
    ProcessInfoWindowComponent,
    ResearchPaperCardComponent
  ],
  templateUrl: './show-message.component.html',
  styleUrl: './show-message.component.scss'
})
export class ShowMessageComponent implements OnDestroy {
  private readonly store: Store = inject(Store);

  readonly isConnected = this.store.selectSignal(selectIsConnected());
  readonly showMessage = this.store.selectSignal(selectShowMessage());
  readonly lastMessage = this.store.selectSignal(selectProcessLastInfo());
  readonly errorMessages = this.store.selectSignal(selectProcessLastErrorMessages());
  readonly lastProcessInfo = this.store.selectSignal(selectLastProcessInfo());
  readonly papers = this.store.selectSignal(selectPapers());

  connectSSERef: EffectRef | undefined;

  showErrors = signal(false);

  constructor() {
    this.connectSSERef = this.store.dispatch(() => startProcessInfoSseStream());
  }

  ngOnDestroy() {
    if (this.connectSSERef) {
      this.connectSSERef.destroy();
    }
  }

  close() {
    this.store.dispatch(() => hideLoadingProcessInfoSseStream());
  }

  removeError(index: number) {
    this.store.dispatch(() => removeInfoErrorMessage({index}));
  }

  getPaper(projectId?: number, paperId?: number) {
    if (!projectId || !paperId) {
      return undefined;
    }
    const papersByProject = this.papers()[projectId] || [];
    const papers = papersByProject.filter(p => p.id === paperId);
    if (papers.length > 0) {
      return papers[0];
    }
    return undefined;
  }

  protected readonly isDevMode = isDevMode;
}
